import React, { Component } from "react";
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from "prop-types";
import { CssBaseline, CircularProgress, Container, Button, Grid, IconButton, Tooltip } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Styles } from "../../styles/material-styles";
import { Overlay } from "../../styles/global";
import CustomizedSnackbars from "../../components/material-snackbars";
import HeaderMenu from "../../components/header-menu";
import MyMaterialTable from '../../components/table';
import Footer from '../../components/footer';
import { injectIntl } from 'react-intl';
import SectionCard from '../../components/section-card';
import Typography from '@material-ui/core/Typography';
import Pagination from '@material-ui/lab/Pagination';
import RefreshIcon from '@material-ui/icons/Refresh';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';
import DangerConfirmDialog from '../../components/danger-confirm-dialog';
import * as componentActions from '../../redux/actions/admin-billing';
import * as adminBillingService from '../../services/admin-billing.service';
import Api from "../../services/api";

const PAGE_SIZE = 20;

class AdminSuspendedPending extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            openNotification: false,
            notificationVariant: 'error',
            notificationMessage: '',
            items: [],
            total: 0,
            page: 1,
            pageStart: 0,
            pageEnd: 0,
            dangerDialog: { open: false, hirerId: null, contractId: null, workspace: '', name: '' },
            dangerLoading: false,
        };
    }

    componentDidMount() { this.load(1); }

    load(page = 1) {
        this.setState({ loading: true });
        const offset = (page - 1) * PAGE_SIZE;
        adminBillingService.getSuspendedPendingDecision(PAGE_SIZE, offset)
            .then(result => {
                if (result.data.success) {
                    const data = result.data.data || {};
                    const items = data.items || [];
                    const total = data.total || 0;
                    const totalPages = Math.ceil(total / PAGE_SIZE);
                    const pageStart = total > 0 ? offset + 1 : 0;
                    const pageEnd = Math.min(offset + items.length, total);

                    const formatted = items.map(it => ({
                        ...it,
                        blockedDateText: it.blockeddate ? new Date(it.blockeddate).toLocaleDateString('pt-BR') : '-',
                        overdueSinceText: it.overduesince ? new Date(it.overduesince).toLocaleDateString('pt-BR') : '-',
                    }));

                    this.setState({ loading: false, items: formatted, total, totalPages, pageStart, pageEnd, page });
                } else {
                    this.showError(result.data.errors?.[0]);
                }
            })
            .catch(err => { this.showError(err.response?.data?.errors?.[0]); Api.kickoff(err); });
    }

    showSuccess = (msg) => this.setState({ loading: false, openNotification: true, notificationVariant: 'success', notificationMessage: msg });
    showError = (msg) => this.setState({ loading: false, openNotification: true, notificationVariant: 'error', notificationMessage: msg || 'Erro ao processar requisição' });
    closeNotification = () => this.setState({ openNotification: false });

    onChangePaginate = (e, page) => this.load(page);

    openDeprovisionDialog = (row) => {
        this.setState({
            dangerDialog: {
                open: true,
                hirerId: row.hirerid,
                contractId: row.contractid ?? null,
                workspace: row.workspace || '',
                name: row.name || '',
            },
        });
    }

    closeDeprovisionDialog = () => this.setState({ dangerDialog: { open: false } });

    confirmDeprovision = ({ reason, confirmWorkspace }) => {
        const { dangerDialog } = this.state;
        if (!dangerDialog?.hirerId || !dangerDialog?.contractId) {
            this.showError('Contrato não identificado para este hirer.');
            return;
        }
        this.setState({ dangerLoading: true });
        adminBillingService.scheduleSubscriptionDeprovisioning(dangerDialog.hirerId, dangerDialog.contractId, { reason, confirmWorkspace })
            .then(result => {
                this.setState({ dangerLoading: false });
                if (result.data.success) {
                    this.setState({ dangerDialog: { open: false } });
                    this.showSuccess('Desprovisionamento agendado. A lista foi atualizada.');
                    this.load(this.state.page);
                } else {
                    this.showError(result.data.errors?.[0]);
                }
            })
            .catch(err => { this.setState({ dangerLoading: false }); this.showError(err.response?.data?.errors?.[0]); Api.kickoff(err); });
    }

    handleKeep = (row) => {
        this.setState({ loading: true });
        adminBillingService.markSuspensionReviewed(row.hirerid)
            .then(result => {
                if (result.data.success) {
                    this.showSuccess('Marcado como revisado. O contrato volta para a lista apenas se o bloqueio avançar mais dias.');
                    this.load(this.state.page);
                } else {
                    this.showError(result.data.errors?.[0]);
                }
            })
            .catch(err => { this.showError(err.response?.data?.errors?.[0]); Api.kickoff(err); });
    }

    render() {
        const { classes, headerMenu } = this.props;

        return (
            <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
                <HeaderMenu />
                <main className={clsx(classes.content, { [classes.contentShift]: headerMenu.open })}>
                    <div className={classes.drawerHeader} />
                    <Container component='main' maxWidth='xl' style={{ paddingLeft: 0, marginLeft: 0 }}>
                        <CssBaseline />

                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <SectionCard
                                    context="warning"
                                    title="Inadimplência pendente de decisão"
                                    subtitle="Contratos suspensos por inadimplência há mais de N dias aguardando decisão manual: desprovisionar ou manter."
                                    actions={
                                        <Tooltip title="Atualizar">
                                            <IconButton onClick={() => this.load(this.state.page)}><RefreshIcon /></IconButton>
                                        </Tooltip>
                                    }
                                >
                                    <Typography variant="body2" style={{ color: '#424242' }}>
                                        Total de registros pendentes: <strong>{this.state.total || 0}</strong>
                                    </Typography>
                                </SectionCard>
                            </Grid>

                            <Grid item xs={12}>
                                {this.state.items.length === 0 && !this.state.loading ? (
                                    <SectionCard context="success" title={null} divider={false}>
                                        <div style={{ textAlign: 'center', padding: 32 }}>
                                            <CheckCircleIcon style={{ fontSize: 56, color: '#bdbdbd' }} />
                                            <Typography variant="h6" style={{ fontWeight: 600, marginTop: 12 }}>Nada pendente por aqui</Typography>
                                            <Typography variant="body2" style={{ color: '#888', marginTop: 4 }}>
                                                Nenhum contrato suspenso aguardando decisão no momento.
                                            </Typography>
                                        </div>
                                    </SectionCard>
                                ) : (
                                    <MyMaterialTable
                                        title=""
                                        columns={[
                                            { title: 'Hirer ID', field: 'hirerid' },
                                            { title: 'Nome', field: 'name' },
                                            { title: 'Workspace', field: 'workspace' },
                                            { title: 'Plano', field: 'planname' },
                                            { title: 'Bloqueado em', field: 'blockedDateText' },
                                            { title: 'Dias bloqueado', field: 'daysblocked' },
                                            { title: 'Vencido desde', field: 'overdueSinceText' },
                                            {
                                                title: 'Ações',
                                                field: 'actions',
                                                render: row => (
                                                    <div style={{ display: 'flex', gap: 6 }}>
                                                        <Tooltip title="Desprovisionar ambiente">
                                                            <IconButton size="small" onClick={() => this.openDeprovisionDialog(row)} style={{ color: '#d32f2f' }}>
                                                                <DeleteForeverIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="Manter (marcar como revisado)">
                                                            <IconButton size="small" onClick={() => this.handleKeep(row)} style={{ color: '#388e3c' }}>
                                                                <CheckCircleIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </div>
                                                ),
                                            },
                                        ]}
                                        data={this.state.items}
                                    />
                                )}
                            </Grid>

                            <Grid item xs={12}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Pagination count={this.state.totalPages || 0} page={this.state.page} onChange={this.onChangePaginate} />
                                    <Typography variant="body2" style={{ color: '#757575' }}>
                                        {this.state.pageStart} - {this.state.pageEnd} de {this.state.total} registro(s)
                                    </Typography>
                                </div>
                            </Grid>
                        </Grid>

                        <DangerConfirmDialog
                            open={this.state.dangerDialog.open}
                            onClose={this.closeDeprovisionDialog}
                            onConfirm={this.confirmDeprovision}
                            workspace={this.state.dangerDialog.workspace}
                            title="Desprovisionar ambiente inadimplente"
                            message={`Agendar desprovisionamento de "${this.state.dangerDialog.name}" (${this.state.dangerDialog.workspace}).`}
                            description="Infra dedicada será derrubada, assinatura no gateway será cancelada e registros SaaS deletados. O banco de dados do contratante é preservado por 30 dias antes da deleção permanente."
                            warningText="Essa ação não pode ser desfeita após o período de carência expirar."
                            confirmLabel="Agendar desprovisionamento"
                            loading={this.state.dangerLoading}
                        />

                        {this.state.loading && (<Overlay><CircularProgress color="secondary" /></Overlay>)}
                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />
                    </Container>
                </main>
                <Footer />
            </div>
        );
    }
}

AdminSuspendedPending.propTypes = { classes: PropTypes.object.isRequired };

const mapStateToProps = state => ({
    headerMenu: state.headerMenu,
    userSession: state.userSession,
});

const mapDispatchToProps = dispatch => bindActionCreators(componentActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(AdminSuspendedPending)));
